module.exports = "https://portperrypedals.ca/_res/img/ppstar.23992cf.jpg";